import React from 'react'
import { Link } from 'react-router-dom'

import withStyles from '@material-ui/core/styles/withStyles'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import ButtonBase from '@material-ui/core/ButtonBase'
import Tab from '@material-ui/core/Tab'
import Tabs from '@material-ui/core/Tabs'

import { Word } from '../../../containers'
import { PuzzlePage, EventTab } from '../containers'
import { getBreakpointsEnable, makePath } from '../../../lib'

import AsyncContainer from 'containers/Common/AsyncContainer'
import { WID } from '../../../constants/Language';
import { useEffect } from 'react'
import { useContext } from 'react'
import { SettingsContext } from '../../../Parts/Settings'
import CustomAvatar from '../../../Parts/CustomAvatar/CustomAvatar'
const ProfilePage = AsyncContainer(() => import(/* webpackChunkName: "ProfilePage" */ '../containers/ProfilePage')
  .then(module => module.default), { name: 'ProfilePage' });

const stylesProfileBox = theme => ({
  profileBox: {
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing.unit * 2,
    width: '100%',
    boxSizing: 'border-box',
  },
  avatar: {
    width: theme.spacing.unit * 10,
    height: theme.spacing.unit * 10,
    marginRight: theme.spacing.unit * 2,
  },
  userNameBox: {
    display: 'flex'
  },
  userName: {
    marginRight: theme.spacing.unit,
  },
  nameBox: {
  }
})

const ProfileBox = withStyles(stylesProfileBox, { withTheme: true })((props) => {
  const { classes, theme, width, userProfile } = props
  
  const settingsContext = useContext(SettingsContext)
  const { language } = settingsContext

  var { sm } = getBreakpointsEnable(theme, width)
  var styles = {
    avatar : {
      marginLeft: sm ? theme.spacing.unit * 5 : 0,
      backgroundColor: userProfile.avatarPhotoURL ? 'none' : theme.palette.primary.light,
    }
  }
  return (
    <div className={classes.profileBox}>
      <CustomAvatar src={userProfile.avatarPhotoURL} className={classes.avatar} style={styles.avatar} name={userProfile.displayName} key={userProfile.userName}/>
      <div className={classes.nameBox}>
        <Typography variant='title' noWrap>{userProfile.displayName}</Typography>
        <div className={classes.userNameBox}>
          <Typography variant='body2' noWrap className={classes.userName}>{`@${userProfile.userName}`}</Typography>
          {userProfile.own && (
            <ButtonBase component={Link} to={makePath('/settings/account', language)}>
              <Typography color='primary'>編集</Typography>
            </ButtonBase>
          )}
        </div>
      </div>
    </div>
  )
})

const userTabItems = [
  { value: 0, disabled: false, name: 'profile', wid: WID.USER_TAB_ITEMS.PROFILE },
  { value: 1, disabled: false, name: 'event',   wid: WID.USER_TAB_ITEMS.EVENT },
  { value: 2, disabled: false, name: 'puzzle',  wid: WID.USER_TAB_ITEMS.PUZZLE },
]

const stylesMenuTab = theme => ({
})

class MenuTab extends React.Component {
  render() {
    const { classes, userName, tabId, language } = this.props
    return (
      <Tabs
        value={tabId}
        indicatorColor="primary"
        textColor="primary"
        scrollable
        className={classes.tabs}
      >
        {userTabItems.map((item, index) => 
          <Tab
            key={index}
            disabled={item.disabled}
            label={<Word wid={item.wid}/>}
            className={classes.tab}
            component={Link}
            to={makePath(`/user/${userName}/${item.name}`, language)}
          />
        )}
      </Tabs>
    )
  }
}

MenuTab = withStyles(stylesMenuTab)(MenuTab)


const styles = theme => ({
  gridProfile: {
    backgroundColor: theme.palette.grey[50],
  },
  gridPage: {
    backgroundColor: theme.palette.common.white,
  },
  headerImageBox: {
    minHeight: theme.spacing.unit * 2,
    backgroundColor: theme.palette.grey[50],
  },
  headerImage: {
    width: '100%',
  },
  pageBox: {
    width: '100%',
    maxWidth: 900,
    margin: '0 auto'
  },
  page: {
    padding: theme.spacing.unit * 4,
    height: 600,
    backgroundColor: theme.palette.common.white,
  },
  profileBox: {
    width: '100%',
    maxWidth: 900,
    margin: '0 auto',
  }
})

function User(props) {
  const { auth0, init, unmount, classes, theme, width, userProfile, tabId, tg, wd, profileBoxSProps, menuTabSProps, menuTabDProps, language } = props
  
  useEffect(() => {
    const { userName } = props.match.params
    let item
    if (auth0) {
      auth0.isAuthenticated()
      .then(result => {
        init(userName)
        item = userTabItems.find(tabItem => tabItem.name === props.match.params.tabName)
        if (item) {
          props.handleChangeTab(item.value)
        }
      })
    }
    return () => {
      unmount()
    }
  }, [auth0])

  useEffect(() => {
    props.init(props.match.params.userName)
  }, [props.match.params.userName])

  useEffect(() => {
    let item
    item = userTabItems.find(tabItem => tabItem.name === props.match.params.tabName)
    if (item) {
      props.handleChangeTab(item.value)
    }
  }, [props.match.params.tabName])

  var { md, sm } = getBreakpointsEnable(theme, width)
  var styles = {
    gridRoot: {
      width: '100%',
      margin:
        md ? `${theme.spacing.unit * 8}px auto` :
        sm ? `${theme.spacing.unit * 8}px auto` : `${theme.spacing.unit * 7}px auto`
    },
  }

  return (
    <Grid container spacing={0} style={styles.gridRoot}>
      {userProfile && (
        <React.Fragment>
          <Grid item xs={12}>
            <div className={classes.headerImageBox}>
              {userProfile.headerPhotoURL && (
                <img src={userProfile.headerPhotoURL} alt={'header'} className={classes.headerImage}/>
              )}
            </div>
          </Grid>
          <Grid item xs={12} className={classes.gridProfile}>
            <div className={classes.profileBox}>
              <ProfileBox {...profileBoxSProps} language={language}/>
              <MenuTab {...menuTabSProps} {...menuTabDProps} language={language}/>
            </div>
          </Grid>
          <Grid item xs={12} className={classes.gridPage}>
            <div className={classes.pageBox}>
              {tabId === 0 ? (
                <ProfilePage userProfile={userProfile}/>
              ) : tabId === 1 ? (
                <EventTab userProfile={userProfile}/>
              ) : tabId === 2 ? (
                <PuzzlePage {...{userName: userProfile.userName, tg, wd, url: props.history.location.pathname}}/>
              ) : (
                <div className={classes.page}>
                </div>
              )}
            </div>
          </Grid>
        </React.Fragment>
      )}
    </Grid>
  )
}

export default withStyles(styles, { withTheme: true })(User)


// WEBPACK FOOTER //
// ./src/Pages/User/components/User.js